var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm._f("numeric")(_vm.perThousand,'0,0.00')))]),_c('div',{staticClass:"font-weight-light caption text-uppercase"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }